import { useEffect, useState } from "react";
import { SidebarCol } from "../../chatMain/Sidebar/Sidebar";
import { MainContentAssessment} from "../MainContentArea/MainContent";
import { MainHeader } from "../../chatMain/MainHeader/MainHeader";
import "./Assessment-dashboard.css";

export const AssessmentDashboard = () => {
 const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
   // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
    };

    // Listen for resize
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="assessment-dashboard">
       {/* Show sidebar only on non-mobile screens */}
      {!isMobile && (
        <div className="sidebar-assessment">
          <SidebarCol />
        </div>
      )}

      <div className="maincontentarea-assessment">
        <div className="header-assessment">
            <MainHeader
              titleText="Explore Your Inner Landscape"
              subtitleText="Choose a path to reflect on where you are today"
            />
        </div>
        <MainContentAssessment />
      </div>
    </div>
  );
};
